/* Delirium — добавяне в количката, съвместимо с Horizon (cart drawer + брояч) */
import { CartLinesUpdateEvent } from '@shopify/events';

const routes = () => (window.Theme && window.Theme.routes) || { cart_add_url: '/cart/add.js', cart_url: '/cart' };

function cartSectionIds() {
  return Array.from(document.querySelectorAll('cart-items-component'))
    .map((el) => el.dataset.sectionId)
    .filter(Boolean);
}

/**
 * Добавя артикули в количката и уведомява темата (drawer-ът се отваря и обновява).
 * @param {Array<{id:number, quantity:number, properties?:object}>} items
 * @param {{context?: string, sourceId?: string}} [opts]
 * @returns {Promise<object>} cart (Ajax API)
 */
export async function addToCart(items, opts = {}) {
  const r = routes();
  const sections = cartSectionIds();
  const deferred = CartLinesUpdateEvent.createPromise();
  const itemCount = items.reduce((a, i) => a + (i.quantity || 1), 0);

  document.dispatchEvent(
    new CartLinesUpdateEvent({
      action: 'add',
      context: opts.context || 'product',
      lines: items.map((i) => ({ merchandiseId: String(i.id), quantity: i.quantity || 1 })),
      promise: deferred.promise,
    })
  );

  try {
    const res = await fetch(r.cart_add_url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items, sections: sections.join(','), sections_url: window.location.pathname }),
    });
    const data = await res.json();
    if (!res.ok || data.status) {
      const err = new Error(data.message || data.description || 'Add to cart failed');
      deferred.reject(err);
      throw err;
    }
    const cart = await fetch(`${r.cart_url}.json`, { headers: { Accept: 'application/json' }, credentials: 'same-origin' }).then((x) => x.json());
    deferred.resolve({
      cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
      detail: {
        items: cart.items,
        source: 'delirium',
        sourceId: opts.sourceId || 'delirium',
        itemCount,
        sections: data.sections,
        didError: false,
      },
    });
    return cart;
  } catch (e) {
    deferred.reject(e);
    throw e;
  }
}

window.DeliriumCart = { add: addToCart };
